// Deterministic per-slug phase offset (seconds) so cards with the same
// image count don't all cycle their images in perfect lock-step with
// each other. djb2 hash -> fraction of the cycle duration.
export function getPhaseOffset(slug, cycleDuration) {
  let hash = 5381;
  const s = slug || '';
  for (let i = 0; i < s.length; i++) {
    hash = ((hash << 5) + hash + s.charCodeAt(i)) | 0;
  }
  const fraction = (Math.abs(hash) % 997) / 997;
  return fraction * cycleDuration;
}
